// extracted by mini-css-extract-plugin
export default {"inactiveWarningBanner":"email-inactive-warning_inactiveWarningBanner__3nsOA","emailPageLink":"email-inactive-warning_emailPageLink__+DzpV"};